import React from "react";
import { ContentPage, Prose } from "../../components/ContentPage";
import { BRAND } from "../../data/site";

export default function Regulamin() {
  return (
    <ContentPage
      testid="page-regulamin"
      eyebrow="Dokumenty"
      title="Regulamin"
      lead="Zasady korzystania ze strony PMPOINT oraz nawiązywania współpracy. Prosimy o zapoznanie się z poniższymi warunkami."
      seo={{
        title: "Regulamin | PMPOINT",
        description: "Regulamin serwisu PMPOINT SP. Z O.O. — zasady korzystania ze strony, składania zgłoszeń rekrutacyjnych i nawiązywania współpracy (18+).",
        canonical: "https://pmpoint.pl/regulamin",
      }}
    >
      <Prose>
        <p><strong>Właściciel serwisu:</strong> {BRAND.legalName}, {BRAND.address}, NIP {BRAND.nip}.</p>

        <h2>1. Postanowienia ogólne</h2>
        <p>Niniejszy regulamin określa zasady korzystania ze strony internetowej pmpoint.pl oraz warunki składania zgłoszeń w celu nawiązania współpracy.</p>

        <h2>2. Wymóg pełnoletności</h2>
        <p>Serwis oraz oferta współpracy skierowane są wyłącznie do osób, które ukończyły 18 lat. Składając zgłoszenie, użytkownik potwierdza swoją pełnoletność.</p>

        <h2>3. Zgłoszenia</h2>
        <ul>
          <li>Zgłoszenie za pomocą formularza jest bezpłatne i niezobowiązujące.</li>
          <li>Podane dane muszą być prawdziwe i aktualne.</li>
          <li>Wysłanie zgłoszenia nie stanowi zawarcia umowy — jest zaproszeniem do kontaktu.</li>
        </ul>

        <h2>4. Zasady współpracy</h2>
        <p>Szczegółowe warunki współpracy (w tym model rozliczeń procentowych, zakres usług i poufność) ustalane są indywidualnie i regulowane odrębną umową.</p>

        <h2>5. Odpowiedzialność</h2>
        <p>Informacje prezentowane na stronie mają charakter ogólny i marketingowy. Prezentowane przykładowe wyniki nie stanowią gwarancji — rzeczywiste rezultaty zależą od profilu, zaangażowania i zakresu współpracy.</p>

        <h2>6. Własność intelektualna</h2>
        <p>Wszystkie materiały na stronie (teksty, grafiki, logo) są chronione prawem autorskim i nie mogą być wykorzystywane bez zgody właściciela.</p>

        <h2>7. Dane osobowe</h2>
        <p>Zasady przetwarzania danych opisano w <a href="/polityka-prywatnosci">Polityce prywatności</a>.</p>

        <h2>8. Kontakt</h2>
        <p>Pytania dotyczące regulaminu: <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a>, tel. {BRAND.phone}.</p>

        <p className="text-sm text-white/40">Dokument ma charakter informacyjny. Zalecamy konsultację treści z prawnikiem i dostosowanie do rzeczywistego modelu działalności.</p>
      </Prose>
    </ContentPage>
  );
}
